import React, { Component } from "react";
import Header from "../../components/Header";
import "./index.css";
import { connect } from "react-redux";
import { push } from "redux-little-router";
import intercom from "../../util/intercom";

class NotFoundPage extends Component {
  render() {
    return (
      <div className="main">
        <Header />
        <div className="main__container">
          <div className="NotFoundPage">
            <h2 className="-title">404</h2>
            <h2>Oops, the page you're looking for does not exist.</h2>
            <p />
            You may want to head back to the homepage. If you think something is broken, report a problem.
            <div className="-buttons-wrapper">
              <button className="button -rounded -outline -centered" onClick={this.props.redirectToHome}>
                RETURN HOME
              </button>
              <button className="button -rounded -outline -centered" onClick={() => intercom.show()}>
                REPORT PROBLEM
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  redirectToHome: () => dispatch(push("/")),
});

export default connect(
  null,
  mapDispatchToProps
)(NotFoundPage);



// WEBPACK FOOTER //
// ./src/scenes/App404/index.js